<template>
  <div>
    <hr class="separator-slim mx-6">
    <div class="search-filter-box p-6">
      <h4 class="fs-20 font-medium mb-4">
        Conservation
      </h4>

      <checkbox v-model="options.greenfin">
        Green Fins member
      </checkbox>
    </div>
  </div>
</template>

<script>
import Checkbox from '../../../components/core/Checkbox'
import ClearFiltersMixin from '../../../mixins/ClearFiltersMixin'

export default {
  mixins: [ClearFiltersMixin],
  components: {
    Checkbox
  },
  data () {
    return {
      options: this.loadOptions()
    }
  },
  methods: {
    loadOptions () {
      const filters = this.$store.state.filters

      const options = {
        greenfin: filters.greenfin === '1'
      }

      return options
    }
  },
  watch: {
    options: {
      deep: true,
      handler (options) {
        this.$store.commit('setFilter', {
          name: 'greenfin',
          value: options.greenfin ? '1' : ''
        })
        this.$store.dispatch('loadSuppliers')
      }
    }
  }
}
</script>
